import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Chatbot from './components/Chatbot';
import './index.css';

// Configure axios
const API_URL = 'https://www.jaganclub.com/backend.php';

function HomePage() {
  const [events, setEvents] = useState([]);
  const [filters, setFilters] = useState({ country: '', locality: '', topic: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}?action=events`, { params: filters });
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
    setLoading(false);
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchEvents();
  };

  return (
    <div className="container">
      <header className="hero">
        <h1>🌍 Welcome to Global Meetings</h1>
        <p>Discover and join meetings, lectures, and events from around the world.</p>
        <p style={{ fontSize: '14px', marginTop: '10px' }}>Need help? Contact us at <a href="mailto:Operations@virtuosogenai.com">Operations@virtuosogenai.com</a> or use the chat below 💬</p>
      </header>

      <form onSubmit={handleFilter} className="filter-form">
        <input type="text" placeholder="Country" value={filters.country} onChange={(e) => setFilters({ ...filters, country: e.target.value })} />
        <input type="text" placeholder="Locality" value={filters.locality} onChange={(e) => setFilters({ ...filters, locality: e.target.value })} />
        <input type="text" placeholder="Topic" value={filters.topic} onChange={(e) => setFilters({ ...filters, topic: e.target.value })} />
        <button type="submit">Search</button>
      </form>

      <section className="events-section">
        <h2>Available Events ({events.length})</h2>
        {loading ? <p>Loading...</p> : events.length === 0 ? (
          <p>No events found. Try adjusting your filters.</p>
        ) : (
          <div className="events-grid">
            {events.map(event => (
              <div key={event.id} className="event-card">
                <h3>{event.title}</h3>
                <p>{event.description}</p>
                <p><strong>📍 Location:</strong> {event.locality}, {event.country}</p>
                <p><strong>📅 Date:</strong> {new Date(event.date_time).toLocaleString()}</p>
                <p><strong>💰 Price:</strong> {event.price} {event.currency}</p>
                <Link to={`/event/${event.id}`} className="btn">View Details</Link>
              </div>
            ))}
          </div>
        )}
      </section>
      <Chatbot />
    </div>
  );
}

function Register() {
  const [formData, setFormData] = useState({ name: '', email: '', password: '', country: '', locality: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${API_URL}?action=register`, formData);
      if (response.data.success) {
        setMessage(response.data.message);
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(response.data.error || 'Registration failed');
      }
    } catch (err) {
      setError('Registration failed. Please try again.');
    }
  };

  return (
    <div className="container">
      <div className="form-container">
        <h2>Register</h2>
        {error && <div className="error">{error}</div>}
        {message && <div className="success">{message}</div>}
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Full Name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
          <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
          <input type="password" placeholder="Password (8+ characters)" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required />
          <input type="text" placeholder="Country" value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })} required />
          <input type="text" placeholder="Locality/City" value={formData.locality} onChange={(e) => setFormData({ ...formData, locality: e.target.value })} required />
          <button type="submit">Register</button>
        </form>
        <p>Need help? Contact <a href="mailto:Operations@virtuosogenai.com">Operations@virtuosogenai.com</a></p>
      </div>
    </div>
  );
}

function Login() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${API_URL}?action=login`, formData);
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        navigate('/');
      } else {
        setError(response.data.error || 'Login failed');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    }
  };

  return (
    <div className="container">
      <div className="form-container">
        <h2>Login</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
          <input type="password" placeholder="Password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required />
          <button type="submit">Login</button>
        </form>
        <p>Don't have an account? <Link to="/register">Register here</Link></p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <nav className="navbar">
        <Link to="/">🌍 Global Meetings</Link>
        <div>
          <Link to="/login">Login</Link>
          <Link to="/register">Register</Link>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
